import { extendTheme } from "@chakra-ui/react";
import { ButtonStyle } from "../components/ui/Button";

const theme = extendTheme({
  fonts: {
    heading: `"IBM Plex Sans JP", sans-serif`,
    body: `"IBM Plex Sans JP", sans-serif`,
  },
  colors: {
    cyan: {
      50: "#DFF4F8",
      700: "#00718D",
    },
  },
  semanticTokens: {
    colors: {
      brand: {
        50: "#EDF5F3",
        100: "#D9EEE9",
        200: "#B3DDD3",
        300: "#8DCCBE",
        400: "#67BBA8",
        500: "#41AA92",
        700: "#276658",
      },
      brandGreen: {
        50: "#ebf6f2",
        100: "#d5ede7",
        200: "#ace1d0",
        300: "#81CFBA",
        500: "#44a38c",
        600: "#33907b",
        700: "#26726c",
      },
      lime: {
        500: "#5F945E",
        700: "#296C21",
      },
      amber: {
        50: "#FCF5E0",
        200: "#F4DA8D",
        400: "#EBBE3A",
      },
      caution: "#CD4429",
      primary: "brand.500",
      textBase: "#212625",
      textLink: "#1A827B",
      textGray: "#6B767B",
      borderDivider: "#C4CCCA",
      gray: {
        base: "#6B6B6B",
        light: "#F2F2F2",
        50: "#F6F8F8",
        100: "#F1F2F4",
        200: "#c9d4da",
        600: "#5c696f",
        700: "#5C696F",
      },
      border: {
        cardOutline: "#DCE5E3",
        input: "#99A9B0",
      },
      text: {
        base: "#212529",
        primary: "#44A38C",
        link: "brandGreen.700",
        caution: {
          dark: "#CD2929",
        },
      },
      background: {
        caution: {
          base: "#FFF3F3",
          light: "#FFF5F5",
        },
      },
      tealBlue: {
        base: "#0088A6",
        light: "#C8EAF2",
      },
    },
  },
  styles: {
    global: {
      body: {
        fontSize: "16px",
        color: "textBase",
      },
    },
  },
  components: {
    Link: {
      baseStyle: {
        color: "textLink",
        textDecoration: "underline",
        _hover: {
          textDecoration: "none",
        },
      },
    },
    Button: ButtonStyle,
  },
});

export default theme;
